import CartHeader from "../Cart/CartHeader";
import OrderSummary from "./OrderSummary.jsx";
import creditcard from "../../../assets/credit-card.png";
import Delivery2 from "../../../assets/pickuplog.png";
import DelveryImage from "../../../assets/deliverypagebike.png"
import GoogleMapsTracking from "./maps.jsx.jsx";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../utils/api.js";
import { clearCart } from "../../../redux/action/cart.js";
import { FiHome } from "react-icons/fi";
import { RiEBike2Fill } from "react-icons/ri";
import { toast } from "react-toastify";
import { showCustomAlert } from "../Signup/Toast.jsx";
import { clearDiscount } from "../../../redux/promoSlice.js";
import {
  FaPoundSign,
  FaPaypal,
  FaRegCircle,
  FaRegDotCircle,
  FaStripe,
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import React, { useEffect, useState , useRef} from "react";
import creditcardlogo from "../../../assets/creditcardlogo.png";
import Cookies from "js-cookie";
import LocationInput from "./LocationInput.jsx";
const SummarycomponetWithPayment = () => {
  const [data, setData] = useState({ deliveryFee: null, serviceFee: null, marketPlaceFee : null });
const [storeInfo , setStoreInfo] = useState([])

const [orderType, setOrderType] = useState(localStorage.getItem('orderType') || 'pickup');
const [phoneNumber, setPhoenNumber] = useState("")
const [Error, setError] = useState("")
const [locationError, setLocationError] = useState("")
const [Notes  , setNotes] = useState("")
const maxChars = 150;
  const [alltotal , setAlltotal ] = useState(0)
  const [address, setAddress] = useState("");
const locationRef = useRef(null)
const PhoneRef = useRef(null)
  console.log('============================address=============', Notes)
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  console.log("🚀 ~ SummarycomponetWithPayment ~ user:", user);
const [storeloacationInfo , setStoreLocationInfo] = useState([])
  const fetchFees = async () => {
    try {
      const [deliveryResponse, serviceResponse, marketPlaceresponse] = await Promise.all([
        api.get(`/order/delivery-fee`),
        api.get(`/cash-back/service-fee`),
        api.get('/order/market-fee'),
        
      ]);

      setData({
        deliveryFee: deliveryResponse.data?.data,
        serviceFee: serviceResponse.data?.data,
        marketPlaceFee: marketPlaceresponse.data?.data
      });
    } catch (err) {
      console.error("Error fetching fees:", err);
    } 
  };
  useEffect(() => {
    const savedPhoneNumber = Cookies.get("phoneNumber");
    const savedNotes = Cookies.get("Notes");

    if (savedPhoneNumber) setPhoenNumber(savedPhoneNumber);
    if (savedNotes) setNotes(savedNotes);
  }, []);

  // Save phoneNumber and Notes to cookies whenever they change
  useEffect(() => {
    Cookies.set("phoneNumber", phoneNumber, { expires: 7 }); // Expires in 7 days
  }, [phoneNumber]);
  useEffect(() => {
    if (user?.notes) {
      setNotes(user.notes);
    }
  }, [user]);
  useEffect(() => {
    Cookies.set("Notes", Notes, { expires: 7 });
  }, [Notes]);
  useEffect(() => {
    fetchFees();
  }, []);
  
  const handleOrderTypeChange = (type) => {
    setOrderType(type);
    localStorage.setItem('orderType', type);
  };
  useEffect(() => {
    const savedOrderType = localStorage.getItem('orderType');
    if (savedOrderType) {
      setOrderType(savedOrderType);
    }
  }, []);
//   useEffect(() => {
//     const set = Cookies.get('orderType')
// console.log("-----------------set-----------------", set)
//   }, []);
  const navigate = useNavigate();

  const [isProcessing, setIsProcessing] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1024) {
        setIconSize(21.66); // Large screens
      } else if (screenWidth >= 768) {
        setIconSize(15.15); // Medium screens
      } else {
        setIconSize(13.79); // Small screens
      }
    };

    handleResize(); // Initial size
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleNotesChange = (e) => {

    const value = e.target.value;
    if (value?.length <= maxChars) {
      setNotes(value);
    }
  };
  useEffect(() => {
    if (window.location.search.includes("session_id")) {
      console.log("session", window.location.search);
      checkPaymentStatus();
    }
  }, []);

  
 
  // Function to handle selection
  const handleSelect = (method) => {
    setSelectedMethod(method);
  };
  
  const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))


  const getLocation =async()=>{
    const response = await api.get(`/restaurant/${RestaurantSavedId}`);
    console.log("🚀 ~ getLocation ~ response", response)
    setStoreInfo(response.data.data)
  }
  useEffect(() => {
    getLocation()
  }, [])
  const createOrder = async (paymentInfo) => {
    const cartItemsCookie = Cookies.get('cartItems');
    const Items = cartItemsCookie ? JSON.parse(cartItemsCookie) : [];
    console.log("===cart======", Items)
    console.log("🚀 ~ createOrder ~ paymentInfo:", paymentInfo);
    const restaurantId =  RestaurantSavedId;

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
     
  
if (!Items || Items?.length === 0) {
  showCustomAlert({
    title: 'Cart is empty!',
    html: '<p style="color: #555;">Please try again</p>',
    icon: 'error',
    confirmButtonText: 'Retry',
    confirmButtonColor: '#af313d',
    background: '#ffffff',
    timer: 125000,
  });

  setTimeout(() => {
    navigate('/menu');
  }, 500);
} else{
  const orderData = {
    userId: paymentInfo.userId,
    receiverPhone: user?.contact || Cookies.get("phoneNumber") || phoneNumber,
    receiverEmail: user.email,
    point: discount?.promoCode?.discount || 0,
    extraNotes: Cookies.get("Notes") || Notes,
    receiverName: user.name,
    paymentIntentId: paymentInfo.transactionId,
    // logo: storeInfo?.logo && storeInfo?.logo[0],
    userAddress: Cookies.get('userAddress'),
    restaurantAddress : Cookies.get('restaurantAddress') || storeInfo?.address,
    items:  cart?.map((item) => ({
      productId: item.productId,

      quantity: item.quantity,
      type: item.type,
      categoryId: item.categoryId,
      name: item.name,
      basePrice: item.basePrice,
      image: item?.image || item?.images[0],
      description: item.description,
    })),
    totalPrice: paymentInfo.orderPrice, // Total price calculated
    offerId: null, // Add offer ID here if needed
    promoCodeId: null, // Add promo code ID if applicable
    restaurantId: restaurantId || null,
    orderType: orderType, // Delivery or Pickup
    paymentMethod: paymentInfo.paymentMethod, // Payment method (Stripe, Credit Card, etc.)
    cash: paymentInfo.orderPrice, // Cash used for payment
    ispoint: paymentInfo.ispoint, // Set ispoint flag based on payment method
  };
console.log("added", orderData)

if(restaurantId){
const orderResponse = await api.post(`/order`, orderData, config);
const orderId = orderResponse?.data?.data?.placeOrder?._id;
console.log(orderResponse)
if (orderId) {
  showCustomAlert({
    title: 'Order placed successfully!',
    html: '<p style="color: #555;">Your Order has been placed</p>',
    icon: 'success',
    confirmButtonText: 'view status',
    confirmButtonColor: '#af313d',
    background: '#ffffff',
    timer: 125000,
  });
  // Cookies.remove('userAddress'),
  Cookies.remove('phoneNumber')
  Cookies.remove('Notes')
  dispatch(clearDiscount());
  
  // Navigate to the order status page with the orderId
  navigate(`/order-status/${orderId}`);

  // After successful order creation, record the transaction
  await createTransaction(paymentInfo, orderId);

  // Clear the discount when needed
  if(orderResponse?.data?.data?.placeOrder?.paymentIntentId === null){
    try {
      const payload = {
        userId  : user?._id,
        pointOrder :"TRUE"
      }
      const response = await api.patch(`/order/checkUserCashback`,payload)
    } catch (error) {
      console.log(error)
    }
  }

  // Clear cart items and latest order from localStorage
  localStorage.setItem("cartItems", JSON.stringify([]));
  localStorage.setItem("latestOrder", JSON.stringify([]));
  localStorage.setItem('cart', JSON.stringify([]));
dispatch(clearCart())
  // Optionally, reload the page if necessary
  window.location.reload();
} else {
  showCustomAlert({
    title: 'ly!',
    html: '<p style="color: #555;">Failed to place Order , Please try again',
   
    icon: 'error',
    confirmButtonText: 'ok',
    confirmButtonColor: '#af313d',
    background: '#ffffff',
    timer: 125000,
  });
}
}else{
console.log('retsaurant Not Found')
}
}

    
    } catch (error) {
      console.log("🚀 ~ createOrder ~ error:", error);
      if (
        error.response?.status === 500 &&
        error.response?.data?.message.includes("duplicate key error")
      ) {
        showCustomAlert({
          title: 'ly!',
          html: '<p style="color: #555;">This transaction has already been used.',
         
          icon: 'error',
          confirmButtonText: 'view status',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
          timer: 125000,
        });
      
      } else {
        showCustomAlert({
          title: 'Please Try Again!',
          html: `<p style="color: #555;">${error.response?.data?.message}`,
         
          icon: 'error',
          confirmButtonText: 'ok',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
          timer: 125000,
        });
      }
    }
  };
  // useEffect(() => {
  //  window.location.reload()
  // }, []);
  
  const createTransaction = async (paymentInfo, orderId) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const transactionData = {
        transactionId: paymentInfo.transactionId,
        userId: paymentInfo.userId,
        orderId: orderId, // Use the actual orderId from the createOrder response
        orderPrice: paymentInfo.orderPrice,
        isActive: true,
        currency: paymentInfo.currency,
        paymentMethod: paymentInfo.paymentMethod,
        confirm: true,
      };

      console.log("🚀 ~ createTransaction ~ transactionData:", transactionData);

      // Make the API call to create the transaction
      await api.post(`/transaction`, transactionData, config);

      // toast.success("Transaction recorded successfully!", {
      //   style: {
      //     backgroundColor: "white", // Background color
      //     color: "#AD343E", // Text color
      //   },
      //   icon: <span style={{ color: "#AD343E" }}>✔</span>, // Custom icon with red color
      // });
    } catch (error) {
      console.error("Error in transaction creation:", error);
      // toast.error("An error occurred while recording the transaction.");
    }
  };

  const checkPaymentStatus = async () => {
    // Show verifying message
    // toast.dismiss();
    // Show verifying message
    showCustomAlert({
      title: 'Please wait ...',
      html: '<p style="color: #555;">Please wait ...</p>',
      icon: 'success',
      confirmButtonText: 'Loading ...',
      confirmButtonColor: '#af313d',
      background: '#ffffff',
      timer: 125000,
    });
    try {
      const response = await api.get(`/stripe/payment_intent/${user._id}`);

      console.log("🚀 ~ checkPaymentStatus ~ response:", response);
      if (response.data.paymentStatus === "succeeded") {
        // toast.dismiss(); // Remove the verifying toast
        // toast.success("Payment verified successfully!");

        // Payment successful, create order
        if (response.data.paymentStatus === "succeeded") {
          await createOrder({
            userId: user._id,
            orderPrice: total,
            transactionId: response.data.payment_intentId,
            currency: response.data.currency,
            paymentMethod: "Stripe",
          });
        
          // Clear cart after order placement
          // dispatch(clearCart());
          // Cookies.remove('cartItems');
        }
        
      } else {
       
        showCustomAlert({
          title: 'Error!',
          html: '<p style="color: #555;">An error occurred. Please try again..</p>',
          icon: 'error',
          confirmButtonText: 'Continue',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
        });
      }
    } catch (err) {
     
      console.error("Error checking payment status:", err);
      showCustomAlert({
        title: 'Error!',
        html: '<p style="color: #555;">An error occurred. Please try again..</p>',
        icon: 'error',
        confirmButtonText: 'Continue',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
      });
    }
  };

 
  const { discount } = useSelector((state) => state.promo);
  const { cart } = useSelector((state) => state.cart);
  const savedCart = Cookies.set('cartItems', JSON.stringify(cart));
  console.log("--------cart========", cart)
  const subtotal = cart.reduce(
    (acc, item) => acc + item.basePrice * item.quantity,
    0
  );
  const location = useLocation();
  const pointsSufficient = location.state?.pointsSufficient;
  console.log('pointsSufficient', pointsSufficient)
  const [selectedMethod, setSelectedMethod] = useState("");
  const [iconSize, setIconSize] = useState(20); // Default size

  // Apply discount only on applicable products
  const discountAmount = cart.reduce((discountTotal, item) => {
    console.log("🔹 Current discountTotal before processing item:", discountTotal);
    console.log("🔹 Checking item:", item._id);
    console.log("🚀 ~ discountAmount ~ discount productId:", discount?.promoCode?.productId);
  
    const isDiscountApplicable =
      discount &&
      Array.isArray(discount?.promoCode?.productId) &&
      discount?.promoCode?.productId.includes(item._id);
  
    console.log("🚀 ~ discountAmount ~ isDiscountApplicable:", isDiscountApplicable);
  
    if (isDiscountApplicable) {
      const itemDiscount = (item.basePrice * item.quantity * discount?.promoCode?.discount) / 100;
      console.log(`✅ Discount applied for item ${item._id}:`, itemDiscount);
  
      discountTotal += itemDiscount;
    }
  
    console.log("🔹 Updated discountTotal after item:", discountTotal);
    return discountTotal;
  }, 0);
  
  console.log("🔥 Final Discount Amount:", discountAmount);
  
   
// const getMarketplace = (orderType)=>{
//   if (orderType === 'pickup' && data?.marketPlaceFee?.isPickup){

//   }
// }
useEffect(() => {
  if (!data) return; // Ensure data is available before calculation
  console.log("Updated Order Type:", orderType);
  console.log("Updated Data:", data);
  const total = subtotal-discountAmount + 
    (orderType  ==='delivery'  ? data?.deliveryFee?.amount || 0 : 0) + 
    (data?.serviceFee?.amount || 0) + 
    ((data?.marketPlaceFee && ((orderType ==='delivery' && data.marketPlaceFee.delivery) || (!orderType ==='pickup' && data.marketPlaceFee.pickup))) 
      ? data.marketPlaceFee.amount 
      : 0);
console.log(total , "total")
  setAlltotal(total);
}, [orderType, data, subtotal, discountAmount]);
  const total = subtotal - discountAmount 
  const shwoTotal = subtotal - discountAmount + 
  (orderType ? data?.deliveryFee?.amount || 0 : 0) + 
  data?.serviceFee?.amount +
  ((orderType && data?.marketPlaceFee?.delivery) || (!orderType && data?.marketPlaceFee?.pickup) ? data?.marketPlaceFee?.amount : 0);


  if (cart?.length === 0) {
    return (
      <section className="flex flex-col self-center px-11 py-9 mt-12 rounded-lg bg-stone-50 w-[90%] max-md:px-5 max-md:mt-10">
        <h2 className="text-2xl font-bold text-black text-center">
          Your cart is empty.
        </h2>
        <p className="text-center text-gray-600 mt-2">
          Please add some items to your cart to view the order summary.
        </p>
      </section>
    );
  }
  const checkPoints = async (point)=> {
    try {
      const payload = {
        userId: `${user?._id}`,
        totalPrice: alltotal,
        points : `${point}`
      }
      const response = await api.post(`/order/checkOrderPrice`, payload)
      console.log(response?.data)
      console.log("API check successful:", response?.data);
      return { success: true, data: response.data };
    } catch (error) {
      showCustomAlert({
            title: "Error!",
            html: `<p style="color: #555;">${error?.response?.data?.message}</p>`,
            icon: "error",
            confirmButtonText: "Okk",
            confirmButtonColor: "#af313d",
            background: "#ffffff",
            timer: null
          });
          return { success: false };
    }
  }

  const checkPointsAndCreateOrder = async () => {
    // Disable button immediately to prevent multiple clicks
    if (isProcessing) return; 
    setIsProcessing(true);
  
    if (!user?.contact && !phoneNumber) {
      setError("Please Enter Your Phone Number");
      // PhoneRef.current.scrollIntoView({ behavior: "smooth" });
      showCustomAlert({
        title: 'Phone Number Is Missing!',
        html: '<p style="color: #555;">Please Enter Your Phone Number</p>',
        icon: 'error',
        confirmButtonText: 'ok',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: 125000,
      });
   
      setIsProcessing(false); // Re-enable button if phone is missing
      return;
    }
    try {
      // Validate phone number before submitting the form
      const validateResponse = await api.post("/order/validatePhone", { phone: user?.contact || phoneNumber });

      if (!validateResponse.data.success) {
        // Swal.fire("Error!", validateResponse.data.message || "Invalid phone number.", "error");
        return; // Stop execution if phone validation fails
      }
    } catch (validationError) {
      console.error("Phone validation failed:", validationError);
       showCustomAlert({
              title: 'Please Try Again!',
              html: `<p style="color: #555;">${validationError?.response?.data?.message}</p>`,
              icon: 'error',
              confirmButtonText: 'ok',
              confirmButtonColor: '#af313d',
              background: '#ffffff',
              timer: 125000,
            });
            setIsProcessing(false); 
    
      return; // Stop execution if phone validation API fails
    }
    const result = await checkPoints('no');
    if (result.success) {
      if (orderType === "delivery" && address === "") {
        showCustomAlert({
          title: "Error!",
          html: '<p style="color: #555;">Please Confirm Your Address</p>',
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#af313d",
          background: "#ffffff",
        });
        if (locationRef?.current) {
          locationRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        setLocationError("Confirm Your Location First")
        setIsProcessing(false); // Re-enable button if address is missing
        return;
      }
  
      try {
        // Call paymentHandler to handle payment and redirect to Stripe Checkout
        await paymentHandler();
      } catch (error) {
        console.error("Error in points and payment check:", error);
        showCustomAlert({
          title: "Error!",
          html: '<p style="color: #555;">An error occurred. Please try again.</p>',
          icon: "error",
          confirmButtonText: "Continue",
          confirmButtonColor: "#af313d",
          background: "#ffffff",
        });
  
        setIsProcessing(false); // Re-enable button on error
      }
    } else {
      setIsProcessing(false); // Re-enable button if points check fails
    }
  };
  
  const checkPointsAndCreateOrderWhenSuffeienctPoints = async () => {
    // Disable button immediately to prevent multiple clicks
    if (isProcessing) return; 
    setIsProcessing(true);
    

    if (!user?.contact && !phoneNumber) {
      // PhoneRef?.current.scrollIntoView({ behavior: "smooth", block: "center" });
      setError("Please Enter Your Phone Number");
      showCustomAlert({
        title: 'Phone Number Is Missing!',
        html: '<p style="color: #555;">Please Enter Your Phone Number</p>',
        icon: 'error',
        confirmButtonText: 'ok',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: 125000,
      });
      
      setIsProcessing(false); // Re-enable button if phone is missing
      return;
    }
    try {
      // Validate phone number before submitting the form
      const validateResponse = await api.post("/order/validatePhone", { phone: user?.contact || phoneNumber });

      if (!validateResponse.data.success) {
        // Swal.fire("Error!", validateResponse.data.message || "Invalid phone number.", "error");
        return; // Stop execution if phone validation fails
      }
    } catch (validationError) {
      console.error("Phone validation failed:", validationError);
       showCustomAlert({
              title: 'Please Try Again!',
              html: `<p style="color: #555;">${validationError?.response?.data?.message}</p>`,
              icon: 'error',
              confirmButtonText: 'ok',
              confirmButtonColor: '#af313d',
              background: '#ffffff',
              timer: 125000,
            });
            // if (PhoneRef?.current) {
            //   PhoneRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            // }
            setIsProcessing(false); 
      return; // Stop execution if phone validation API fails
    }
    const result = await checkPoints('yes');
    if (result.success) {
      if (orderType === "delivery" && address === "") {
        showCustomAlert({
          title: "Error!",
          html: '<p style="color: #555;">Please Enter Address</p>',
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#af313d",
          background: "#ffffff",
        });
        setLocationError("Confirm This Location")
        setIsProcessing(false); // Re-enable button if address is missing
        return; 
      }
  
      try {
        // Call paymentHandler to handle payment and redirect to Stripe Checkout
        await createOrder({
          userId: user._id,
          orderPrice: total,
          paymentMethod: "discount",
          transactionId: null,
          currency: null,
          ispoint: true,
        });
        dispatch(clearDiscount());
      } catch (error) {
        console.error("Error in points and payment check:", error);
        showCustomAlert({
          title: "Error!",
          html: '<p style="color: #555;">An error occurred. Please try again.</p>',
          icon: "error",
          confirmButtonText: "Continue",
          confirmButtonColor: "#af313d",
          background: "#ffffff",
        });
  
        setIsProcessing(false); // Re-enable button on error
      }
    } else {
      setIsProcessing(false); // Re-enable button if points check fails
    }
  };
  
  
  // This function handles payment and redirects to Stripe Checkout
  const paymentHandler = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const description = cart
        ?.map((item) => `${item.name} x${item.quantity}`)
        .join(", ");
      const title = `Order of ${cart?.length} items`;
      const successUrl = `${window.location.href}?session_id={CHECKOUT_SESSION_ID}`; // Pass session_id in URL

      const paymentData = {
        totalPrices: total,
        description,
        title,
        orderType: orderType ,
        successUrl,
      };

      // Send payment request to backend to generate Stripe session
      const { data } = await api.post(
        `stripe/check-out/${user._id}`,
        paymentData,
        config
      );

      if (data.session) {
        const sessionUrl = data.session.url; // Get the session URL from the backend
        console.log("Redirecting to Stripe Checkout URL:", sessionUrl);
        window.location.href = sessionUrl; // Redirect to the Stripe Checkout URL
      } else {
        showCustomAlert({
          title: 'Error!',
          html: '<p style="color: #555;">An error occurred. Please try again..</p>',
          icon: 'error',
          confirmButtonText: 'Continue',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
        });
      }
    } catch (error) {
      console.error("Error in payment handling:", error);
      showCustomAlert({
        title: 'Error!',
        html: '<p style="color: #555;">An error occurred. Please try again..</p>',
        icon: 'error',
        confirmButtonText: 'Continue',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
      });
    }
  };

  // Automatically trigger payment verification after the redirect when session_id is present in the URL
  // if (window.location.search.includes("session_id")) {
  //   checkPaymentStatus();
  // }
 
  const shouldShowMarketFee =
  data?.marketPlaceFee &&
  ((orderType === "delivery" && data.marketPlaceFee.delivery) ||
    (orderType === "pickup" && data.marketPlaceFee.pickup));

  return (
    <>
      <CartHeader />
      <div className="mt-8 flex justify-between lg:max-w-[500px] lg:h-[95px] max-w-[114.11px] h-[35.75px] sm:max-w-[114.11px] sm:h-[35.75px] md:max-w-[206.49px] md:h-[68.04px] bg-[#AF313D] rounded-full mx-auto mb-6 items-center cursor-pointer">
      <div className="lg:w-[480px] lg:h-[83px] w-[104.11px] h-[30.75px] sm:w-[104.11px] sm:h-[30.75px] md:w-[196.49px] md:h-[58.04px] mx-auto bg-[#AF313D] flex gap-4 items-center justify-center rounded-full relative">
        <div
          className={`absolute left-0 w-1/2 h-full bg-[#ffff] rounded-full transition-transform duration-300 ${
            orderType === 'delivery' ? "translate-x-0" : "translate-x-full"
          }`}
        ></div>
        <div
          className={`flex-1 flex items-center justify-center z-10 ${
            orderType === 'delivery' ? "text-[#af313d]" : "text-white"
          }`}
          onClick={() => handleOrderTypeChange('delivery')}
        >
          <div>
            <RiEBike2Fill
            className="lg:w-[53px] lg:h-[53px] w-[19.64px] h-[19.64px] sm:w-[19.64px] sm:h-[19.64px] md:w-[37.06px] md:h-[37.06px]"
            />
          </div>
          <h1 className="font-baloo font-bold lg:text-[30px] md:text-[20.98px] text-[11.11px] sm:text-[11.11px] lg:tracking-[.1rem] ml-2 hidden md:flex">
            Delivery
          </h1>
        </div>
        <div
          className={`flex-1 flex items-center justify-center z-10 ${
            orderType === 'pickup' ? "text-[#af313d]" : "text-white"
          }`}
          onClick={() => handleOrderTypeChange('pickup')}
        >
          <div>
            <FiHome
            className="lg:w-[53px] lg:h-[53px] w-[19.64px] h-[19.64px] sm:w-[19.64px] sm:h-[19.64px] md:w-[37.06px] md:h-[37.06px]"
            />
          </div>
          {/* <img
            src={Delivery2}
            
            alt="Pick Up"
          /> */}
          <h1 className="font-baloo font-bold lg:text-[30px] md:text-[20.98px] text-[11.11px] sm:text-[11.11px] lg:tracking-[.1rem] ml-2 hidden md:flex">
            Pick Up
          </h1>
        </div>
      </div>
    </div>
      <div className=" mt-2  mb-4">
        <div className=" bg-gray-50 w-[90%] mx-auto shadow-sm">
          <h2 className="lg:text-[48px] text-[12.15px] sm:text-[12.15px] md:text-[27.96px] font-bold font-baloo mb-4 items-center flex justify-center md:py-4 md:pb-8">
            Order Summary
          </h2>
          <OrderSummary cartItems={cart} />
        </div>
      </div>
      <div className=" mt-2  mb-4 ">
        <div className=" w-[90%]  bg-gray-50 mx-auto shadow-lg rounded-sm">
          <div className=" flex items-center justify-center">
            <button className=" lg:w-[553px] mt-5 lg:h-[71.63px] lg:text-[40px] text-[15.14px] md:w-[386.54px] md:text-[27.96px] sm:text-[15.14px] sm:w-[167.88px] md:h-[49.63px] h-[21.55] sm:h-[21.55] w-[167.88px]  bg-[#AF313D] rounded-md text-white font-bold ">
              Personal Details
            </button>
          </div>
          <div className="px-4 flex flex-col gap-4 mt-8 ">
            <div className="flex justify-between items-center">
              <h1 className="font-baloo font-medium text-[#21203C] lg:text-[28.79px] text-[12.74px] sm:text-[12.74px] md:text-[20.12px]">
                Name
              </h1>
              <h1 className=" font-baloo font-semibold lg:text-[28.55px] text-[#21203C] md:text-[20.15px] sm:text-[10.49px] text-[10.49px]">
                {user.name}
              </h1>
            </div>
            <div className="flex justify-between items-center">
              <h1 className="font-baloo font-medium text-[#21203C] lg:text-[28.79px] text-[12.74px] sm:text-[12.74px] md:text-[20.12px]">
                Email
              </h1>
              <h1 className="font-baloo font-semibold lg:text-[28.55px] text-[#21203C] md:text-[20.15px] sm:text-[10.49px] text-[10.49px]">
                {user.email}
              </h1>
            </div>{" "}
            <div className="flex justify-between items-center">
              <h1 className="font-baloo font-medium text-[#21203C] lg:text-[28.79px] text-[12.74px] sm:text-[12.74px] md:text-[20.12px]">
                Phone Number
              </h1>
              <h1 className="font-baloo font-semibold lg:text-[28.55px] text-[#21203C] md:text-[20.15px] sm:text-[10.49px] text-[10.49px]">
                {user.contact || "---"}
              </h1>
            </div>{" "}
          </div>
        </div>
        {/* <p>Delivery Fee: {data.marketPlaceFee?.amount}</p> */}
      </div>
     {!user?.contact && (
       <div  className=" mt-2  mb-4 ">
       <div ref={PhoneRef} className=" w-[90%]  bg-gray-50 mx-auto shadow-lg rounded-sm">
         <div className=" flex items-center justify-center">
           <button className=" lg:w-[553px] mt-5 lg:h-[71.63px] lg:text-[40px] text-[15.14px] md:w-[386.54px] md:text-[27.96px] sm:text-[15.14px] sm:w-[167.88px] md:h-[49.63px] h-[21.55] sm:h-[21.55] w-[167.88px]  bg-[#AF313D] rounded-md text-white font-bold ">
             Phone Number
           </button>
         </div>
         <div className="px-4 flex flex-col gap-4 mt-8 ">
         
       
           <div className="flex justify-between items-center">
             {/* <h1 className="font-baloo font-medium text-[#21203C] lg:text-[28.79px] text-[12.74px] sm:text-[12.74px] md:text-[20.12px]">
               Phone Number
             </h1> */}
            <div className="flex flex-col w-full items-center mb-8 ">
              <input
                type="text"
                placeholder="Enter your phone number"
                value={phoneNumber}
                onChange={(e) => setPhoenNumber(e.target.value) }
                className=" w-full md:max-w-[90%]  font-baloo px-5 flex items-center  justify-center lg:h-[71.63px] lg:text-[20px] text-[15.14px]  md:text-[18px]   sm:w-full md:h-[49.63px] h-[40px] sm:h-[40px]  p-2 border border-gray-300  focus:outline-none focus:border-[#AF313D]"
              />
             {Error  && (
              <p className=" text-rose-700 body">{Error}</p>
             )}
              
            </div>
           </div>{" "}
         </div>
       </div>
       {/* <p>Delivery Fee: {data.marketPlaceFee?.amount}</p> */}
     </div>
     ) }
    
      {orderType === 'delivery' && (
        <>
        <div ref={locationRef} className="mt-2 mb-4">
          <div className="w-[90%] mx-auto shadow-lg rounded-sm bg-gray-50 pb-4">
          <div className=" flex items-center justify-center mt-8">
            <button className=" lg:w-[553px] mt-5 lg:h-[71.63px] lg:text-[40px] text-[15.14px] md:w-[386.54px] md:text-[27.96px] sm:text-[15.14px] sm:w-[167.88px] md:h-[49.63px] h-[21.55] sm:h-[21.55] w-[167.88px]  bg-[#AF313D] rounded-md text-white font-bold ">
              Location
            </button>
          </div>
          
         <GoogleMapsTracking userAddress={address} restaurantAddress={storeInfo?.address} setUserAddress={setAddress} setOrderType={()=>handleOrderTypeChange('pickup')}/>
         {locationError  && (
              <p className=" text-rose-700 body flex justify-center items-center w-full mx-auto">{locationError}</p>
             )}
          <div className="flex flex-col md:w-[90%] w-full justify-center mx-auto items-center mb-8">
  <textarea
    type="text"
    placeholder="Any Additional Information"
    
    value={Notes}
    onChange={handleNotesChange}
    className="w-full md:max-w-[90%] px-5 py-3 flex items-center justify-center lg:text-[20px] text-[15.14px] md:text-[18px] font-baloo border border-gray-300 focus:outline-none focus:border-[#AF313D]"
  />
  <span className="text-gray-500 text-sm mt-2">
    {Notes?.length}/{maxChars} characters
  </span>
</div>
          </div>
          
        </div>
       
        </>
      )}
      <div className=" mt-2  mb-4">
        <div className=" w-[90%] mx-auto shadow-lg rounded-sm bg-gray-50 pb-4">
          <div className=" flex items-center justify-center mt-8">
            <button className=" lg:w-[553px] mt-5 lg:h-[71.63px] lg:text-[40px] text-[15.14px] md:w-[386.54px] md:text-[27.96px] sm:text-[15.14px] sm:w-[167.88px] md:h-[49.63px] h-[21.55] sm:h-[21.55] w-[167.88px]  bg-[#AF313D] rounded-md text-white font-bold ">
              Order Summary
            </button>
          </div>
          <section className="flex flex-col self-center px-4 md:py-9 md:mt-8  rounded-lg bg-stone-50   max-md:px-5 max-md:my-10 ">
            <div className="flex justify-between items-center">
              <div className=" flex flex-col md:leading-[64px] leading-[40px]">
                {cart.map((item, index) => (
                  <div
                    key={index}
                    className={`
             rotate-[3.469446951953614e-18rad] font-baloo font-medium text-[#000000] text-[12.74px] sm:text-[12.74px] md:text-[17.48px] lg:text-[25px]`}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
              <div className="flex flex-col self-end  font-semibold whitespace-nowrap md:leading-[64px] leading-[40px] text-slate-800 ">
                {cart.map((item, index) => (
                  <div
                    key={index}
                    className="rotate-[9.19348695318866e-19rad] text-[12.74px] sm:text-[12.74px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]  "
                  >
                    <div className="flex items-center ">
                      <FaPoundSign className="mr-1" />
                      {item.basePrice * item.quantity}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <hr className="shrink-0 mt-1.5  w-full border-rose-700 border-solid border-[2px] max-w-full" />

<div className=" mt-4 flex  flex-col">
  <div className="flex justify-between items-center text-center">
    <div className=" font-baloo font-bold lg:text-[22px] text-[12.74px] sm:text-[12.74px] md:text-[16.78px]">
      Subtotal
    </div>
    <div className=" lg:text-[34px] font-bold text-[12.74px] sm:text-[12.74px] md:text-[20.98px]">
      <div className="flex items-center ">
        <FaPoundSign className="mr-1" />
        {subtotal}
      </div>
    </div>
  </div>
  </div>
            <hr className="shrink-0 mt-1.5  w-full border-rose-700 border-solid border-[2px] max-w-full" />
            <div className=" mt-4 flex  flex-col">
               {discount && (
                          <div className="flex justify-between mt-4">
                            <div className="font-baloo font-bold lg:text-[22px] text-[12.74px] sm:text-[12.74px] md:text-[16.78px] ">
                              Discount
                            </div>
                            <div className="text-[12.74px] sm:text-[12.74px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]">
                              {" "}
                              <div className="flex items-center ">
                              &pound; -{discountAmount.toFixed(2)}
                              </div>
                           
                            </div>
                          </div>
                        )}
             {orderType === 'delivery' && (
               <div className="flex justify-between items-center text-center">
               <div className=" font-baloo font-bold lg:text-[22px] text-[12.74px] sm:text-[12.74px] md:text-[16.78px]">
                 Delivery Fee
               </div>
               <div className=" text-[12.74px] sm:text-[12.74px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]">
                 <div className="flex items-center ">
                 &pound;
                   {data?.deliveryFee?.amount}
                 </div>
               </div>
             </div>
             )}
              <div className="flex justify-between items-center text-center">
                <div className=" font-baloo font-bold lg:text-[22px] text-[12.74px] sm:text-[12.74px] md:text-[16.78px]">
                 Service Fee
                </div>
                <div className=" text-[12.74px] sm:text-[12.74px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]">
                  <div className="flex items-center ">
                    <FaPoundSign className="mr-1" />
                    {data?.serviceFee?.amount}
                  </div>
                </div>
              </div>
             {shouldShowMarketFee && (
               <div className="flex justify-between items-center text-center">
               <div className=" font-baloo font-bold lg:text-[22px] text-[12.74px] sm:text-[12.74px] md:text-[16.78px]">
               Marketplace Fee
               </div>
               <div className=" text-[12.74px] sm:text-[12.74px] md:text-[20.98px] font-baloo font-semibold lg:text-[30px]">
                 <div className="flex items-center ">
                   <FaPoundSign className="mr-1" />
                   {data?.marketPlaceFee?.amount}
                 </div>
               </div>
             </div>
             )}
              </div>
            <hr className="shrink-0 mt-1.5  w-full border-rose-700 border-solid border-[2px] max-w-full" />

            <div className=" mt-4 flex  flex-col">
             
              <div className="flex justify-between mt-4">
                <div className=" text-[#C97C2A] font-baloo font-bold lg:text-[30px] text-[12.74px] sm:text-[12.74px] md:text-[20.98px] ">
                  Total
                </div>
                <div className=" text-[#C97C2A] font-baloo font-bold text-[12.74px] sm:text-[12.74px] lg:text-[40px] md:text-[27.97px]">
                  <div className="flex items-center ">
                    <FaPoundSign className="mr-1" />
                    {alltotal}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
     {!pointsSufficient && (
       <div className="container mx-auto mt-8 w-[90%] md:w-[90%] shadow-md  bg-stone-50 border-[#FDFDFD] border md:mb-5">
       <h1 className="lg:text-[59.61px] text-[24px] md:text-[41.68px] sm:text-[24px] font-baloo font-semibold text-center mb-6">
         Payment Method
       </h1>

       <form className="w-[90%] md:w-full mx-auto  md:p-6 p-0 rounded-lg sm:mb-3 mb-3">
         <div className="flex flex-col md:gap-8 gap-8 md:flex-row md:space-x-4 mb-4">
           {/* Credit/Debit Card Option */}
           <div className="flex-1 gap-4 flex flex-col relative">
             <label
               className="relative w-full cursor-pointer"
               onClick={() => handleSelect("creditcard")}
             >
               <input
                 type="radio"
                 name="paymentMethod"
                 value="creditcard"
                 className="hidden"
               />
               <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] sm:h-[42.8px] border-gray-300 rounded-md placeholder:text-[9.91px] sm:placeholder:text-[9.91px] md:placeholder:text-[10.93px] lg:placeholder:text-[15.63px] hover:border-blue-500 transition duration-200">
                 {selectedMethod === "creditcard" ? (
                   <FaRegDotCircle
                     className="text-blue-500 "
                     size={iconSize}
                   />
                 ) : (
                   <FaRegCircle className="text-gray-500 " size={iconSize} />
                 )}
                 <img
                   src={creditcardlogo}
                   alt="Logo"
                   className="h-[17.25px] w-[24.83px] sm:h-[17.25px] sm:w-[24.83px] lg:w-[38.99px] lg:h-[28.16px] mr-2"
                 />
                 <span className="lg:text-[25.99px] md:text-[18.18px] text-[16.55px] sm:text-[16.55px] text-[#515978] font-baloo font-medium">
                   Credit Card / Debit Card
                 </span>
               </div>
             </label>
           </div>

           {/* Stripe Option */}
           <div className="flex-1 gap-4 flex flex-col relative">
             <label
               className="relative w-full cursor-pointer"
               onClick={(event) => {
                 handleSelect("stripe");
               }}
             >
               <input
                 type="radio"
                 name="paymentMethod"
                 value="stripe"
                 className="hidden"
               />
               <div className="flex items-center gap-2 w-full p-2 pl-6 border lg:h-[67.22px] h-[42.8px] sm:h-[42.8px] border-gray-300 rounded-md placeholder:text-[9.91px] sm:placeholder:text-[9.91px] md:placeholder:text-[10.93px] lg:placeholder:text-[15.63px] hover:border-blue-500 transition duration-200">
                 {selectedMethod === "stripe" ? (
                   <FaRegDotCircle className="text-blue-500" size={iconSize} />
                 ) : (
                   <FaRegCircle className="text-gray-500" size={iconSize} />
                 )}
                 <FaStripe className="text-[#635BFF] text-2xl sm:text-3xl md:text-4xl lg:text-6xl" />
                 <span className="lg:text-[25.99px] md:text-[18.18px] text-[16.55px] sm:text-[16.55px] text-[#515978] font-baloo font-medium">
                   Stripe
                 </span>
               </div>
             </label>
           </div>
         </div>
       </form>
     </div>
     )}
      <div className=" w-[95%] flex items-center ml-auto">
        <div className=" w-[40%]">
          <Link to="/my-cart">
            <button className="flex items-center justify-center lg:w-[121.19px] md:w-[84.58px] md:h-[34.1px] w-[52.95px] h-[21.35px] sm:w-[52.95px] sm:h-[21.35px] lg:h-[48.79px] bg-[white] px-2 py-2 lg:mt-8 text-[#AF313D] border-[#AF313D] shadow-md mt-2 text-[7.4px] sm:text-[7.4px] lg:text-[16.91px] font-baloo font-semibold rounded-[2rem] md:text-[11.82px] mb-3">
              Back
            </button>
          </Link>
        </div>
       {!pointsSufficient ? (
         <div className=" w-[60%] md:block flex justify-end items-end px-4">
         <button
           onClick={checkPointsAndCreateOrder}
           disabled={!selectedMethod || isProcessing } // Disable during processing or if no method selected
           className={`flex items-center justify-center lg:w-[258.19px] md:w-[180.41px] md:h-[52.44px] w-[132.74px] h-[29.28px] sm:w-[132.74px] sm:h-[29.28px] lg:h-[75px] px-2 py-2 lg:mt-8 shadow-md mt-2 font-baloo font-semibold rounded-[2rem] md:text-[18.18px] mb-3 ${
             selectedMethod && !isProcessing
               ? "bg-[#AF313D] text-white"
               : "bg-gray-300 text-gray-500 cursor-not-allowed"
           }`}
         >
           {isProcessing ? "Processing..." : "Place Order"}
         </button>
       </div>
       ): (
        <div className=" w-[60%] md:block flex justify-end items-end px-4">
      <button
  onClick={checkPointsAndCreateOrderWhenSuffeienctPoints}
  disabled={isProcessing} 
  className={`flex items-center justify-center lg:w-[258.19px] md:w-[180.41px] md:h-[52.44px] w-[132.74px] h-[29.28px] sm:w-[132.74px] sm:h-[29.28px] lg:h-[75px] px-2 py-2 lg:mt-8 shadow-md mt-2 font-baloo font-semibold rounded-[2rem] md:text-[18.18px] mb-3 ${
    !isProcessing
      ? "bg-[#AF313D] text-white"
      : "bg-gray-300 text-gray-500 cursor-not-allowed"
  }`}
>
  {isProcessing ? "Processing..." : "Place Order"}
</button>

      </div>
       )}
      </div>
    </>
  );
};

export default SummarycomponetWithPayment;
